import { createTypes, createAction } from 'lib/action'

// ประวัติยอดจองคอนกรีต (ClickUp 86d47txe6)
const GET_SALE_ORDER_HISTORY = createTypes('saleorderhistory', 'get')

const getSaleOrderHistory = {
  request: (data) => createAction(GET_SALE_ORDER_HISTORY.REQUEST, { data }),
  success: (lists) => createAction(GET_SALE_ORDER_HISTORY.SUCCESS, { lists }),
  failure: () => createAction(GET_SALE_ORDER_HISTORY.FAILURE),
}

export { GET_SALE_ORDER_HISTORY, getSaleOrderHistory }
